import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Input } from '../../ui/input';
import { inventoryApi, fmtQty, localToday } from './inventoryApi';

const Stat = ({ label, value, accent, testId }) => (
  <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-3">
    <p className="text-gray-500 text-xs">{label}</p>
    <p className={`font-bold text-xl ${accent}`} data-testid={testId}>{value}</p>
  </div>
);

export const ReportPanel = () => {
  const [date, setDate] = useState(localToday());
  const [data, setData] = useState({ items: [], totals: {} });

  const load = useCallback(async () => {
    try { setData(await inventoryApi.report(date)); } catch (e) { toast.error(e.message); }
  }, [date]);
  useEffect(() => { load(); }, [load]);

  const t = data.totals || {};
  return (
    <div className="space-y-3" data-testid="inventory-report">
      <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="w-44 bg-black/50 border-gray-700 text-white" data-testid="report-date" />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <Stat label="Costo de insumos vendidos" value={`$${(t.consumed_cost || 0).toFixed(2)}`} accent="text-orange-300" testId="report-consumed-cost" />
        <Stat label="Compras (entradas)" value={`$${(t.purchased_cost || 0).toFixed(2)}`} accent="text-emerald-300" testId="report-purchased-cost" />
        <Stat label="Mermas" value={`$${(t.waste_cost || 0).toFixed(2)}`} accent="text-red-300" testId="report-waste-cost" />
      </div>
      <div className="bg-gray-900/50 border border-gray-800 rounded-xl overflow-x-auto">
        {data.items.length === 0 ? (
          <p className="text-gray-500 text-center py-10" data-testid="report-empty">Sin consumo registrado este día</p>
        ) : (
          <table className="w-full min-w-[760px] text-sm">
            <thead>
              <tr className="text-gray-500 text-xs">
                <th className="py-2 px-3 text-left font-medium">Insumo</th>
                <th className="py-2 px-3 text-right font-medium">Consumido</th><th className="py-2 px-3 text-right font-medium">Costo consumo</th>
                <th className="py-2 px-3 text-right font-medium">Entradas</th><th className="py-2 px-3 text-right font-medium">Mermas</th>
                <th className="py-2 px-3 text-right font-medium">Ajustes</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.item_id} className="border-t border-gray-800" data-testid={`report-row-${r.item_id}`}>
                  <td className="py-2 px-3 text-white">{r.name}</td>
                  <td className="py-2 px-3 text-right text-orange-300 font-semibold">{fmtQty(r.consumed)} {r.unit}</td>
                  <td className="py-2 px-3 text-right text-gray-200">${r.consumed_cost.toFixed(2)}</td>
                  <td className="py-2 px-3 text-right text-emerald-300">{r.purchased ? `+${fmtQty(r.purchased)} ${r.unit}` : '—'}</td>
                  <td className="py-2 px-3 text-right text-red-300">{r.waste ? `${fmtQty(r.waste)} ${r.unit}` : '—'}</td>
                  <td className="py-2 px-3 text-right text-blue-300">{r.adjusted ? `${r.adjusted > 0 ? '+' : ''}${fmtQty(r.adjusted)} ${r.unit}` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
